export type IMyDownloads = {
	myDownloadsId: number;
	registrationId: number;
	fileGuid: string;
	fileName: string;
	filePath: string;
	fileSize: number;
	fileCount: number;
	createdOn: Date;
	status: MyDownloadStatus;
	storageAccountId: number;
};

export enum MyDownloadStatus {
	None = 0,
	Processing = 1,
	Completed = 2,
	Failed = 3,
}
